<template>
  <v-card width="100%" color="#FFFFFFE6" class="base-card">
    <v-row justify="center">
      <p>{{ dialogText }}</p>
    </v-row>
    <v-row justify="center" class="button-area" v-if="device == 'pc'">
      <v-col cols="6">
        <NormalSimpleSolidButton
          button-title="いいえ"
          @clickAction="negativeAction"
        />
      </v-col>
      <v-col cols="6">
        <NormalSimpleBlackButton
          button-title="はい"
          @clickAction="positiveAction"
        />
      </v-col>
    </v-row>
    <v-row justify="center" class="button-area" v-if="device == 'sp'">
      <v-col cols="12">
        <NormalSimpleBlackButton
          button-title="はい"
          @clickAction="positiveAction"
        />
      </v-col>
      <v-col cols="12">
        <NormalSimpleSolidButton
          button-title="いいえ"
          @clickAction="negativeAction"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import NormalSimpleSolidButton from "../Atoms/NormalSimpleSolidButton";
import NormalSimpleBlackButton from "../Atoms/NormalSimpleBlackButton";
export default {
  name: "Dialog",
  data: () => ({}),
  methods: {
    negativeAction() {
      this.$emit("negativeAction");
    },
    positiveAction() {
      this.$emit("positiveAction");
    }
  },
  created() {},
  components: {
    NormalSimpleSolidButton,
    NormalSimpleBlackButton
  },
  props: ["dialogText", "device"]
};
</script>

<style scoped>
p {
  color: #000;
  font-weight: bold;
  margin: 30px;
  font-size: 1.5em;
}
.base-card {
  box-shadow: 0px 6px 9px #00000029;
  opacity: 1;
  border-radius: 30px;
}
.button-area {
  width: 700px;
}
@media screen and (max-width: 350px) {
  p {
    font-size: 1em;
  }
  .button-area {
    width: 250px;
    margin: 0;
    padding: 10px 20px;
  }
}
@media screen and (min-width: 351px) and (max-width: 768px) {
  p {
    font-size: 1.2em;
  }
  .button-area {
    width: 300px;
    margin: 0;
    padding: 10px 20px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  p {
    font-size: 1.3em;
  }
  .button-area {
    width: 600px;
    padding: 10px 20px;
  }
}
@media screen and (min-width: 1024px) {
  p {
    font-size: 1.3em;
  }
  .button-area {
    width: 600px;
    padding: 10px 20px;
  }
}
</style>
